export let colors = {
    red          : 'rgb(255, 99, 132)',
    orange       : 'rgb(255, 159, 64)',
    yellow       : 'rgb(255, 205, 86)',
    green        : 'rgb(75, 192, 192)',
    blue         : 'rgba(54, 162, 235, 0.7)',
    purple       : 'rgb(153, 102, 255)',
    grey         : '#b3b3b3',
    good         : '#C1C1C1',
    info         : '#154889',
    none         : '#154889',
    low          : 'rgba(247, 186, 11, 0.7)',
    medium       : 'rgba(212, 101, 47, 0.7)',
    high         : 'rgba(160, 33, 40, 0.7)',
    critical     : 'rgba(144, 70, 132, 0.7)',
    low_fill     : 'rgba(247, 186, 11, 0.1)',
    medium_fill  : 'rgba(212, 101, 47, 0.1)',
    high_fill    : 'rgba(160, 33, 40, 0.1)',
    critical_fill: 'rgba(144, 70, 132, 0.1)',
    status_blue  : 'rgba(26, 106, 156, 0.7)',
    status_lblue : 'rgba(59, 180, 220, 0.7)',
    status_gray  : 'rgba(84, 84, 84, 0.7)',
    status_lgray : 'rgba(158, 158, 158, 0.7)',
    red_family   : {
        lighter: "#C9190B",
        light  : "#A30000",
        medium : "#7D1007",
        dark   : "#470000",
        darker : "#2C0000"
    },
    black_family   : {
        lighter: "#F0F0F0",
        light  : "#D2D2D2",
        medium : "#B8BBBE",
        dark   : "#8A8D90",
        darker : "#6A6E73"
    },
};

export default {
    colors,
}
